/**
 * @generated SignedSource<<46843c83e6c94a8b15e58c16d9d376f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentSectionsContent$data = {
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name?: string;
      readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "helpersCheckIfNewsSectionInFirstIndexSection">;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "contentSectionsContent";
};
export type contentSectionsContent$key = {
  readonly " $data"?: contentSectionsContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentSectionsContent">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v1 = {
  "kind": "InlineFragment",
  "selections": (v0/*: any*/),
  "type": "Section",
  "abstractKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentSectionsContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "VideoSection",
              "abstractKey": null
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersCheckIfNewsSectionInFirstIndexSection",
              "selections": [
                (v1/*: any*/)
              ],
              "args": null,
              "argumentDefinitions": []
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "entityLink"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};
})();

(node as any).hash = "510ab3ae10f165bb71b12cb557386755";

export default node;
